import { Component, OnInit, ViewChild } from '@angular/core';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { combineLatestWith, filter, map, Observable, startWith } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { checkRouterChildsData } from '@vex/utils/check-router-childs-data';
import { BreakpointObserver } from '@angular/cdk/layout';
import { VexConfigService } from "@vex/config/vex-config.service";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { VexSidebarComponent } from '@vex/components/vex-sidebar/vex-sidebar.component';
import { MatDrawerMode } from '@angular/material/sidenav';
import { VexConfig } from '@vex/config/vex-config.interface';
import { FlowAccountService } from '../services/flow-account.service';


@UntilDestroy()
@Component({
  selector: 'vex-custom-layout',
  templateUrl: './custom-layout.component.html',
  styleUrls: ['./custom-layout.component.scss']
})
export class CustomLayoutComponent implements OnInit {
  config$: Observable<VexConfig>;
  sidenavCollapsed$: Observable<boolean>;
  sidenavDisableClose$: Observable<boolean>;
  sidenavFixedInViewport$: Observable<boolean>;
  sidenavMode$: Observable<MatDrawerMode>;
  sidenavOpen$: Observable<boolean>;
  configPanelOpen$: Observable<boolean>;
  quickpanelOpen$: Observable<boolean>;
  isFooterVisible$: Observable<boolean>;

  constructor(
    private readonly layoutService: VexLayoutService,
    private readonly configService: VexConfigService,
    private readonly flowAccountService: FlowAccountService,
  ) {}

  ngOnInit(): void {
  this.config$ = this.configService.config$;
  this.sidenavCollapsed$ = this.layoutService.sidenavCollapsed$;
  this.sidenavDisableClose$ = this.layoutService.isDesktop$;
  this.isFooterVisible$  = this.configService.config$.pipe(map(config => config.footer.visible));
  this.sidenavMode$ = this.layoutService.isDesktop$.pipe(
    combineLatestWith(
      this.configService.select(config => config.layout)
    ),
    map(([isDesktop, layout]) => (isDesktop && layout !== 'vertical') ? 'side' : 'over')
  );
  this.sidenavOpen$ = this.layoutService.sidenavOpen$;
  this.configPanelOpen$ = this.layoutService.configPanelOpen$;
  this.quickpanelOpen$ = this.layoutService.quickpanelOpen$;
  }

  onSidenavClosed(): void {
    this.layoutService.closeSidenav();
  }

  onQuickpanelClosed(): void {
    this.layoutService.closeQuickpanel();
  }


  onSignedOut() {
		this.flowAccountService.logout();
	}
}
